import Header from './components/Header';
import ProductScan from './components/ProductScan';
import { BrowserRouter as Router, Routes, Route,Switch } from 'react-router-dom';
import PurchaseOrder from './components/PurchaseOrder';
import PayOrder from './components/PayOrder';
import Login from './components/Login';

function App() {
  return (
    <div className="App">
      <Header/>
      <Router>
        <Routes>
           <Route path="/productentry" element={<ProductScan />} />
           <Route path="/purchase-order" element={<PurchaseOrder />} />
           <Route path="/payorder" element={<PayOrder />} />
           <Route path="/user" element={<Login />} />
        </Routes>
      </Router>
    </div>
  );
}

export default App;
